export default (languageCode: string) => /* GraphQL */ `
mutation AddInspirations($ids: [ID!]!) {
  inspirations: addInspirations(ids: $ids languageCode: "${languageCode}") {
    id
    shortId
    url
    slug 
  }
}`;
